import React from "react";
import "../styles/Footer.css";
import { FaLinkedin, FaGithub } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Abikrishna. All Rights Reserved.</p>
      <div className="footer-socials">
        <a href="https://www.linkedin.com/in/abikrishna-sivananthan" target="_blank" rel="noreferrer">
          <FaLinkedin size={22} />
        </a>
        <a href="https://github.com/abikrishnas99" target="_blank" rel="noreferrer">
          <FaGithub size={22} />
        </a>
      </div>
    </footer>
  );
}
